import { render } from "./ProjectCharts.vue?vue&type=template&id=8a45471c"
import script from "./ProjectCharts.vue?vue&type=script&lang=js"
export * from "./ProjectCharts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Riman\\Web\\Alex\\newmapper\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__